/**
 * This is just a simple wrapper for the configuration object.
 *
 * Currently it's being generated from WP with localize script.
 */

export default window.emFeedConfig || {
  jobsApiUrl: '',
  text: [],
};
